import { render } from "./AllocationPoolView.vue?vue&type=template&id=77cc47fb&scoped=true"
import script from "./AllocationPoolView.vue?vue&type=script&lang=js"
export * from "./AllocationPoolView.vue?vue&type=script&lang=js"

import "./AllocationPoolView.vue?vue&type=style&index=0&id=77cc47fb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77cc47fb"]])

export default __exports__